exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Context Menu */\n._3ioWyknSnnlwGTg2XyWtPp {\n  position: absolute;\n  background-color: #ffffff;\n  min-width: 120px;\n  height: 130px;\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12),\n    0px 1px 16px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12),\n    0px 1px 16px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  z-index: 1000;\n  overflow: auto;\n}\n\n._3ioWyknSnnlwGTg2XyWtPp a {\n  color: #142A39;\n  padding: 5px 12px;\n  text-decoration: none;\n  display: block;\n  font-size: 14px;\n}\n\n._3ioWyknSnnlwGTg2XyWtPp a:hover {\n  background-color: #e2e7e3;\n}\n", ""]);

// exports
exports.locals = {
	"dropdownContent": "_3ioWyknSnnlwGTg2XyWtPp"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/IntervalContextMenu/IntervalContextMenu.css
// module id = 10464
// module chunks = 23